<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-25 09:13:22
 * @LastEditTime: 2019-08-27 12:11:11
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div
    id="appMap"
    class="div_appMap"
  >

    <!-- <UCMain ref="ucMain"></UCMain> -->
    <onlineMap></onlineMap>

  </div>
</template>



<script>
import onlineMap from "./components/map.vue";

export default {
  components: {
    onlineMap
  }
};
</script>

<style>
.div_appMap {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
